import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'


const getTranslateMasterFilters = function () {
  return {
    codProducto: { label: i18n.t('invoices.invoices_issuing.cod_producto'), value: '' },
    descripcion: { label: i18n.t('invoices.invoices_issuing.descripcion'), value: '' },
    cantidadMax: { label: i18n.t('invoices.invoices_issuing.step4.cantidad_max'), value: '', type: 'number' },
    cantidadMin: { label: i18n.t('invoices.invoices_issuing.step4.cantidad_min'), value: '', type: 'number' },
    precioUnitarioMax: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_max'), value: '', type: 'number' },
    precioUnitarioMin: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_min'), value: '', type: 'number' },
    totalMax: { label: i18n.t('invoices.invoices_issuing.step4.total_max'), value: '', type: 'number' },
    totalMin: { label: i18n.t('invoices.invoices_issuing.step4.total_min'), value: '', type: 'number' },
    descuento: { label: i18n.t('invoices.invoices_issuing.descuento'), value: '', type: 'number' },
    cuota: { label: i18n.t('invoices.invoices_issuing.discount_cuota'), value: '', type: 'number' },
  } 
}
const getTranslateColumns = () => [
  { field: 'selected', width: '50px', headerCell: (h) => h('span'), locked: true, lockable: false, columnMenu: false, reorderable: false, groupable: false },
  { field: 'Name', title: i18n.t('app.name'), columnMenu: 'myTemplate', width: '300px', locked: false },
  { field: 'TaxType', title: i18n.t('impuestos.TaxType'), format: 'TIPOS_CODIGO_IMPUESTO', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '300px', locked: false },
  { field: 'TaxRate', title: i18n.t('impuestos.TaxRate'), cell: 'numberTemplate', format: 'percent_decimal', columnMenu: 'myTemplate', width: '300px', locked: false },
  { field: 'idImpuesto', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
  // {
  //   field: ' ',
  //   title: '',
  //   width: '100px',
  //   headerCell: (h) => h('span'),
  //   cell: 'actionsTemplate',
  //   locked: true,
  //   lockable: false,
  //   columnMenu: false,
  //   reorderable: false,
  //   filterable: false,
  //   resizable: false,
  //   groupable: false,
  //   extraparams: {
  //     // actionId: 'idAccion',
  //     // actionIcon: 'icon',
  //     actions: [
  //       { idAccion: 2, label: i18n.t('app.edit'), icon: 'editpencil' },
  //       { idAccion: 3, label: i18n.t('app.remove'), icon: 'trash' }
  //     ]
  //   } 
  // }
]
const mystore = parent({ getTranslateColumns, navigate: false, namespaced: true, getTranslateMasterFilters })

export default mystore
